import { Mail, PhoneCall, Instagram } from "lucide-react";
import { useLocation } from "react-router-dom";
import NavLogo from "../../assets/images/LogoPk.png";
import NavLogo2 from "../../assets/images/NewLogoAmerica.jpg";
import { useUser } from "../../context/useUser";
import { Link } from "react-router-dom";

const Footer = () => {
    const location = useLocation();
    const { country, isCustomerLoggedIn, customer } = useUser()
    if (location.pathname.startsWith('/alifadmin') || location.pathname.startsWith('/AlifAdmin')) {
        return null;
    } else if (location.pathname.startsWith('/country-version')) {
        return null;
    }


    return (
        <footer className="bg-[#1a1a1a] text-white pb-12 px-6 md:px-16">
            <div className="max-w-[1350px] mx-auto px-6 md:px-8 pt-20  grid grid-cols-1 md:grid-cols-5 gap-y-10 md:gap-x-12 text-center md:text-left">
                <div className="md:col-span-2 flex flex-col items-center md:items-start">
                    <div className="flex items-center space-x-2">
                        <img src={country === "PK" ? NavLogo : NavLogo2} alt="Farm Logo" className={`${country === "PK" ? "h-20" : "h-12"}`} />
                        <h2 className="text-2xl font-semibold">{country === "PK" ? "Alif Cattle & Goat Farm" : "Alif Meat Packing"}</h2>
                    </div>
                    <p className="text-gray-400 text-sm mt-3 leading-relaxed max-w-sm">
                        Premium-quality beef, mutton, and chicken—sourced with care,
                        processed hygienically, and delivered fresh. Taste the
                        difference today!
                    </p>
                    <div className="mt-4 flex flex-wrap justify-center md:justify-start gap-2">
                        <div>
                            <div className="flex items-center space-x-2">
                                <PhoneCall size={16} />
                                {
                                    country === "PK" ?
                                        <span className="text-white font-medium">0305-2023333</span> :
                                        <span className="text-white font-medium">(888)321-ALIF</span>
                                }

                            </div>
                            <div className="w-[140px] h-[2px] bg-green-400 mt-3"></div>
                        </div>
                        <span className="text-gray-400 inline-block mx-2">or</span>
                        <div>
                            <div className="flex items-center space-x-2">
                                <Mail size={16} />
                                <span className="text-white font-medium">admin@aliffarms.com</span>
                            </div>
                            <div className="w-[130px] h-[2px] bg-green-400 mt-3"></div>
                        </div>
                    </div>
                </div>
                <div className="md:col-span-3 grid grid-cols-2 sm:grid-cols-4 gap-y-6 md:gap-x-8">
                    <div>
                        <h3 className="text-white text-xl font-semibold mb-3">My Account</h3>
                        <ul className="text-gray-400 text-[13px] space-y-3">
                            <Link to={`${isCustomerLoggedIn === true ? `/dashboard/>${customer?.id}` : `auth`}`}><li className="my-3">My Account</li></Link>
                            <Link to='/cart'><li className="my-3"><li className="text-white font-semibold">Shopping Cart</li></li></Link>
                            <Link to='/wishlist'><li className="my-3"><li>Wishlist</li></li></Link>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-white text-xl font-semibold mb-3">Helps</h3>
                        <ul className="text-gray-400 text-[13px] space-y-3">
                            <ul className="text-gray-400 text-[13px] space-y-3">
                                <Link to='/contact-us'><li className="my-3">Contact</li></Link>
                                <Link to='/f-a-q'><li className="my-3">FAQs</li></Link>
                                <Link to='/terms-conditions'><li className="my-3">Terms & Condition</li></Link>
                                <Link to='/privacy-policy'><li className="my-3">Privacy Policy</li></Link>
                            </ul>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-white text-xl font-semibold mb-3">General</h3>
                        <ul className="text-gray-400 text-[13px] space-y-3">
                            <Link to='/about-us'><li className="my-3">About</li></Link>
                            <Link to='/shop/chicken'><li className="my-3">Shop</li></Link>
                            <Link to='/shop/mutton'><li className="my-3">Product</li></Link>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-white text-xl font-semibold mb-3">Categories</h3>
                        <ul className="text-gray-400 text-[13px] space-y-3">
                            <Link to='/shop/beef'><li className="my-3">Beef Products</li></Link>
                            <Link to='/shop/chicken'><li className="my-3">Chicken Products</li></Link>
                            <Link to='/shop/mutton'><li className="my-3">Mutton Products</li></Link>
                            <Link to='/book-your-qurbani'><li className="my-3">Qurbani with Alif</li></Link>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="max-w-[1350px] h-full flex flex-col justify-center mx-auto px-6 md:px-8">
                <hr className="bg-[#75828f] border-[#75828f] h-0.5 mt-8 mb-6" />
                <div className="flex justify-between items-center flex-wrap gap-4">
                    <p className="text-gray-400 text-sm">
                        {country === "PK" ? "Alif Cattle & Goat Farm © 2025. All Rights Reserved" : "Alif Farm © 2025. All Rights Reserved"}
                    </p>
                    <p className="text-gray-400 flex items-center gap-3 text-sm">
                        <a href="https://www.instagram.com/devsphereteam?igsh=MWV5Z24wZ2IxamZqdQ=="><Instagram /></a> Developed by Team DevSphere
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
